var $ = require("jquery");

mapboxgl.accessToken = 'pk.eyJ1IjoiY2FwcmFkaW8iLCJhIjoiY2puY2Jzem4wMWxtNzN2cGVmbzE2c3BteCJ9.v1v-X7uD2g6feNZiAEM1CQ';
var map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/mapbox/light-v9',
  center: [-121.483934, 38.450310],
  zoom: 11.0,
  minZoom: 5.0,
  maxZoom: 16,
});

map.on('load', function () {
    map.addSource('residents', {
        type: 'vector',
        url: 'mapbox://capradio.cjsm8kti02ja82rmnw6m4phep-8pnlq'
    });

    var url = 'https://s3-us-west-1.amazonaws.com/capradio.dailygraphics.staging/maps/neighborhoods.geojson';
    map.addSource('city', { 
        type: 'geojson', 
        data: url
    });
    // map.addLayer({
    //     'id': 'residents',
    //     'type': 'fill',
    //     'source': 'residents',
    //     "paint": {
    //         "fill-color": "#006993",
    //         "fill-opacity": 0.4
    //     },
    //     'source-layer': 'meadowview_boundaries_combined'
    // });

    map.addLayer({
        'id': 'Residents',
        'type': 'line',
        'source': 'residents',
        "layout": {
            "line-join": "round",
            "line-cap": "round"
        },
        "paint": {
            "line-color": "#e49e26",
            "line-width": 7,
            "line-blur": 7,
            "line-opacity": 0.75
        },
        'source-layer': 'meadowview_boundaries_combined'
    });

    map.addLayer({
        'id': 'City',
        'type': 'line',
        'source': 'city',
        "layout": {
            "line-join": "round",
            "line-cap": "round"
        },
        "paint": {
            "line-color": "#23a8b3",
            "line-width": 5,
            "line-blur": 1,
            "line-opacity": 1	
        },
        "filter": ['==', 'NAME', 'Meadowview']
    });

});

map.addControl(new mapboxgl.NavigationControl());
// map.scrollZoom.disable();
// map.dragPan.disable();

map.fitBounds([[
  -121.519,38.4314
  ], [
  -121.417,38.5071
]], {padding: 20});

var toggleableLayerIds = [ 'Residents', 'City' ];

for (var i = 0; i < toggleableLayerIds.length; i++) {
    var id = toggleableLayerIds[i];

    var link = document.createElement('a');
    link.href = '#';
    link.className = 'active';
    link.textContent = id;
    link.id = id;

    link.onclick = function (e) {
        var clickedLayer = this.textContent;
        e.preventDefault();
        e.stopPropagation();

        var visibility = map.getLayoutProperty(clickedLayer, 'visibility');

        if (visibility === 'visible') {
            map.setLayoutProperty(clickedLayer, 'visibility', 'none');
            this.className = '';
        } else {
            this.className = 'active';
            map.setLayoutProperty(clickedLayer, 'visibility', 'visible');
        }
    };

    var layers = document.getElementById('menu');
    layers.appendChild(link);
}

document.getElementById('interact').addEventListener('click', function(e) {

	if (this.className == 'inactive') {
		map.dragPan.enable();
		this.className = 'active';
	} else {
		map.dragPan.disable();
		this.className = 'inactive';
	}
});

$('.close').click(function(){
	$('.overlay-content').toggle();
	$('.fa.fa-chevron-up').toggle();
	$('.fa.fa-chevron-down').toggle();
	$('.moreInfo').toggle();
});